import styled from 'styled-components';
import CloseIcon from 'mdi-react/CloseIcon';
import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress, Divider } from '@material-ui/core';

import { BoldTitle } from '../Jobs/styled';
import { Row, Col } from '../../../styles/snowm_styled';
import { getRelativeDate } from '../../../helpers/date';
import { getProviderByUid } from '../../../controllers/snowm_firebase';

const InfoWindow = ({ point, onClose }) => {
  const [crewInfo, setCrewInfo] = useState({});
  const [reportInfo, setReportInfo] = useState({});

  useEffect(() => {
    let isSubscribe = true;
    if (point.uid) {
      getProviderByUid(point.uid).then((response) => {
        if (isSubscribe) {
          setCrewInfo({
            ...response,
            lastUpdated: point.last_seen,
          });
        }
      });
    } else if (point.jobReport) {
      if (isSubscribe) {
        setReportInfo({
          ...point,
        });
      }
    }

    return () => {
      isSubscribe = false;
    };
  }, []);

  const handleInfoWindowClose = () => {
    onClose();
  };

  if (point.uid || point.jobReport) {
    return (
      <StyledWindowContainer>
        {Object.keys(crewInfo).length !== 0 ? (
          <Row>
            <Col>
              <Row justify="center">
                {crewInfo.imageUrl && (
                  <img
                    height="30px"
                    width="30px"
                    src={crewInfo.imageUrl}
                    alt="crew"
                    style={{
                      borderRadius: '50%',
                    }}
                    onError={(e) => {
                      e.target.src =
                        'data:image/jpeg;base64,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';
                    }}
                  />
                )}
              </Row>
              <StyledTypography style={{ textAlign: 'center' }}>
                {crewInfo.name}
              </StyledTypography>
              <Row justify="center">
                <StyledTypography>{crewInfo.email}</StyledTypography>
              </Row>
              <Row justify="center">
                <StyledTypography>Last updated:</StyledTypography>
                <BoldTitle style={{ fontSize: 12, marginLeft: 3 }}>
                  {getRelativeDate(crewInfo.lastUpdated)}
                </BoldTitle>
              </Row>
            </Col>
            <Col
              style={{
                marginBottom: '6em',
              }}
            >
              <StyledCloseIcon onClick={handleInfoWindowClose} />
            </Col>
          </Row>
        ) : (
          <Col
            style={{
              height: '100%',
            }}
          >
            {Object.keys(reportInfo).length !== 0 ? (
              <Row>
                <Col>
                  <Row justify="center">
                    <BoldTitle>{reportInfo.type}</BoldTitle>
                  </Row>
                  <Row justify="center">
                    {reportInfo.message ? reportInfo.message : 'Not Available'}
                  </Row>
                </Col>
                <Col
                  style={{
                    marginBottom: '6em',
                  }}
                >
                  <StyledCloseIcon onClick={handleInfoWindowClose} />
                </Col>
              </Row>
            ) : (
              <Row
                style={{
                  height: '100%',
                }}
                justify="center"
              >
                <CircularProgress />
              </Row>
            )}
          </Col>
        )}
      </StyledWindowContainer>
    );
  }
  if (point.beaconId) {
    return (
      <StyledWindowContainer>
        <Row>
          <Col>
            <Row justify="center">
              <StyledTypography>Marker Details</StyledTypography>
            </Row>
            <Row>
              <StyledRoutesMarker>{point.name}</StyledRoutesMarker>
            </Row>
            <Divider />
            <Row style={{ marginTop: 5 }}>
              <StyledRoutesMarker>{point.address}</StyledRoutesMarker>
            </Row>
          </Col>
          <Col
            style={{
              marginBottom: '6em',
            }}
          >
            <StyledCloseIcon onClick={handleInfoWindowClose} />
          </Col>
        </Row>
      </StyledWindowContainer>
    );
  }
  return <div />;
};

export default InfoWindow;

const StyledTypography = styled(Typography)`
  && {
    font-size: 12px;
    font-weight: ${(props) => props.weight};
  }
`;

const StyledWindowContainer = styled.div`
  background-color: white;
  position: absolute;
  border-radius: 12px;
  left: -100px;
  top: -175px;
  padding: 8px;
  height: 10em;
  width: 18em;
  z-index: 1;
  overflow: auto;
`;

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`;

const StyledRoutesMarker = styled(BoldTitle)`
  && {
    font-size: 12px;
    margin-left: 3px;
  }
`;
